import { Route, Routes } from "react-router-dom";
import { DesignPackageProductCardPage } from "src/routes/libraries/design-catalog/design-package-configurator/DesignPackageProductCardPage";
import {
  designCatalogPath,
  designPackageAddProductPath,
  designPackageProductCardPath,
  designPackageProductSearchPath,
} from "src/routes/routesDef";
import { DesignPackageConfigurator } from "./DesignPackageConfigurator";
import { DesignPackageConfiguratorProvider } from "./DesignPackageConfiguratorContext";
import { AddProductPage } from "./components/AddProductPage";
import { ProductSearchPage } from "./routes/search/ProductSearchPage";

export function DesignPackageConfiguratorLayout() {
  return (
    <DesignPackageConfiguratorProvider>
      <Routes>
        <Route path={designPackageProductCardPath} element={<DesignPackageProductCardPage />} />
        <Route path={designPackageProductSearchPath} element={<ProductSearchPage />} />
        <Route path={designPackageAddProductPath} element={<AddProductPage />} />
        <Route path={designCatalogPath} element={<DesignPackageConfigurator />} />
      </Routes>
    </DesignPackageConfiguratorProvider>
  );
}
